import * as querystring from "querystring";

export const SET_LOADING_SITES = "SET_LOADING_SITES";
export const INIT_SITES = "INIT_SITES";
export const LOAD_SITES_SUCCESS = "LOAD_SITES";
export const LOAD_SITES_ERROR = "LOAD_ERROR";
export const ATTACH_SITE = "ATTACH_SITE";

export function setLoading() {
  return {
    type: SET_LOADING_SITES,
  };
}

export function attachSite(siteId) {
  return {
    type: ATTACH_SITE,
    payload: { selectedSite: siteId },
  };
}

export function filterSites(
  filterText,
  nonCommissionedOnly,
  latitude: number,
  longitude: number,
  limit: number = 10,
  offset: number = 0
) {
  let params = {
    limit: limit,
    offset: offset,
  };

  if (filterText) {
    params.filterText = filterText;
  }

  if (latitude !== null && longitude !== null) {
    params.latitude = latitude;
    params.longitude = longitude;
  }

  if (nonCommissionedOnly) {
    params.nonCommissionedOnly = true;
  }

  const endpoint = "/installer/filterSites?" + querystring.stringify(params);

  return {
    type: INIT_SITES,
    meta: {
      endpoint: endpoint,
      success: filterSitesSuccess,
    },
  };
}

function filterSitesSuccess(response) {
  if (response.status === "OK") {
    return {
      type: LOAD_SITES_SUCCESS,
      payload: {
        sites: response.data,
      },
    };
  } else {
    return {
      type: LOAD_SITES_ERROR,
      payload: {
        error: "An error occurred when trying to search sites by address",
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/customer.js